export default "__VITE_ASSET__Bb6t7xGy__"